export default class Pedido {
	constructor(
		cliente_id='',
		descricao='',
		estagio_id='',
		prazo='',
		data=''
	){
		this.cliente_id = cliente_id;
		this.descricao = descricao;
		this.estagio_id = estagio_id;
		this.prazo = prazo;

		// Settando a data atual
		if(data){
			this.data = data;
		} else {
			var d = new Date();

			// Dia atual
			var day = d.getDate();
			if(day < 10){
				day = "0"+day
			}

			// Mês atual
			var month = d.getMonth() + 1;
			if(month < 10){
				month = "0"+month
			}

			this.data = d.getFullYear()+'-'+month+'-'+day;
		}
	}
}